<template>
  <section class="section-promotions px-4" v-if="promotions">
    <div class="row">
      <div class="col-12 p-2">
        <carousel :perPage="perPage"
                  :autoplay="true"
                  :centerMode="true"
                  :autoplayHoverPause="true"
                  :navigationEnabled="true"
                  :paginationEnabled="false"
                  :loop="true"
                  :autoplayTimeout="3000"
                  :scrollPerPage="false"
                  :mouseDrag="true"
                  :touchDrag="true">
          <template v-for="promotion in promotions">
            <slide @slideclick="openUrl(promotion)">
              <div class="m-2 pointer-item">
                <img v-lazy="promotion.image_xl"
                     alt=""
                     class="img-fluid rounded">
              </div>
            </slide>
          </template>
        </carousel>
      </div>
    </div>
    <sweet-modal ref="modal"
                 overlay-theme="dark"
                 :width="modalWidth"
                 hide-close-button
                 @close="setSelectedPromotionId()"
                 :enable-mobile-fullscreen="false">
      <template slot="default" class="p-0">
        <div class="text-right mb-1">
          <a href="" @click.prevent="closeModal()">
            <i class="fas fa-2x fa-times-circle text-white"></i>
          </a>
        </div>
        <div v-if="selectedPromotion">
          <a :href="selectedPromotion.page_url" target="_blank" @click="closeModal()">
            <img :src="selectedPromotion.image_popup" alt="" class="img-fluid img-promotion">
          </a>
        </div>
      </template>
    </sweet-modal>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { Carousel, Slide } from 'vue-carousel'
  import { SweetModal } from 'sweet-modal-vue'
  import userEventLogHelpers from '../../helpers/userEventLogHelpers'

  export default {
    components: {
      Carousel,
      Slide,
      SweetModal
    },
    props: {
      perPage: Number
    },
    data () {
      return {
        modalWidth: 400,
        selectedPromotion: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('promotion', ['promotions', 'selectedPromotionIds'])
    },
    watch: {
      promotions () {
        if (this.user && this.promotions) {
          for (const promotion of this.promotions) {
            if (promotion.type === 'popup' && this.selectedPromotionIds.indexOf(promotion.id) === -1) {
              this.selectedPromotion = promotion
              setTimeout(() => {
                this.openModal()
              }, 1000)
              break
            }
          }
        }
      }
    },
    methods: {
      openUrl (promotion) {
        if (promotion.landing_page === 'promotion_detail') {
          this.$router.push(`/promotions/${promotion.id}`)
        } else {
          // Save user event log
          userEventLogHelpers.logEvent('view_promotion', {
            promotion_id: promotion.id
          })
          // Open promotion url
          let url = promotion.page_url
          // if (promotion.is_dynamic_url === 1 && this.user) {
          //   url += '?user_id=' + this.user.id
          // }
          window.open(url, '_blank')
        }
      },
      setSelectedPromotionId () {
        this.$store.commit('promotion/SET_SELECTED_PROMOTION_IDS', this.selectedPromotion.id)
      },
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$store.commit('promotion/SET_SELECTED_PROMOTION_IDS', this.selectedPromotion.id)
        this.$refs.modal.close()
      }
    },
    async mounted () {
      // Resize modal popup
      if (this.$mq.phone) {
        this.modalWidth = Math.ceil(window.screen.width * 0.9)
      }

      let queryData = null
      if (this.user) {
        queryData = {
          params: {
            user_id: this.user.id
          }
        }
      }
      await this.$store.dispatch('promotion/LOAD_PROMOTIONS', queryData)
      // For testing promotion popup
      // this.$store.commit('promotion/SET_SELECTED_PROMOTION_IDS', null)
    }
  }
</script>

<style scoped>
  .sweet-modal-overlay.theme-dark {
    background: rgba(24, 32, 40, 0.4);
  }

  .img-promotion {
    max-width: 90%;
    border-radius: 1rem;
  }

  .section-promotions >>> .sweet-content {
    background-color: transparent;
    padding: 0 !important;
  }

  .section-promotions >>> .sweet-modal {
    box-shadow: none;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/promotion/Slider.vue